import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import TrackedSwitch from 'components/TrackedSwitch';

import PageAmortizationList, { path as PageAmortizationListPath } from 'pages/CalculatorTariff/PageAmortizationList';
import PageCalculation, { path as PageCalculationPath } from 'pages/CalculatorTariff/PageCalculation';
import PageCheckList, { path as PageCheckListPath } from 'pages/CalculatorTariff/PageCheckList';
import PageCheckListSchemaList, {
  path as PageCheckListSchemaListPath,
} from 'pages/CalculatorTariff/PageCheckListSchemaList';
import PageDepartmentList, { path as PageDepartmentListPath } from 'pages/CalculatorTariff/PageDepartmentList';
import PageGateMarkList, { path as PageGateMarkListPath } from 'pages/CalculatorTariff/PageGateMarkList';
import PageFixedItemList, { path as PageFixedItemListPath } from 'pages/CalculatorTariff/PageFixedItemList';
import PageMaterialsOutsourcingList, {
  path as PageMaterialsOutsourcingListPath,
} from 'pages/CalculatorTariff/PageMaterialsOutsourcingList';
import PageModelList, { path as PageModelListPath } from 'pages/CalculatorTariff/PageModelList';
import PagePersonalSalaryList, {
  path as PagePersonalSalaryListPath,
} from 'pages/CalculatorTariff/PagePersonalSalaryList';
import PagePersonalWorkloadList, {
  path as PagePersonalWorkloadListPath,
} from 'pages/CalculatorTariff/PagePersonalWorkloadList';
import PagePriceListServicesList, {
  path as PagePriceListServicesListPath,
} from 'pages/CalculatorTariff/PagePriceListServicesList';
import PageProjectCalculations, {
  path as PageProjectCalculationsPath,
} from 'pages/CalculatorTariff/PageProjectCalculations';
import PageProjectList, { path as PageProjectListPath } from 'pages/CalculatorTariff/PageProjectList';
import PageActsOnSigning, { path as PageActsOnSigningPath } from 'pages/PageActsOnSigning';
import PageMySurveyActs, { path as PageMySurveyActsPath } from 'pages/PageMySurveyActs';
import PageAppIndicatorList, { path as PageAppIndicatorListPath } from 'pages/PageAppIndicatorList';
import PageApplication, { path as PageApplicationPath } from 'pages/PageApplication';
import PageApplicationList, { path as PageApplicationListPath } from 'pages/PageApplicationList';
import PageApplicationNew, { path as PageApplicationNewPath } from 'pages/PageApplicationNew';
import PageApplicationPpr, { path as PageApplicationPprPath } from 'pages/PageApplicationPpr';
import PageApplicationPprList, { path as PageApplicationPprListPath } from 'pages/PageApplicationPprList';
import PageApplicationQuestionableList, {
  path as PageApplicationQuestionableListPath,
} from 'pages/PageApplicationQuestionableList';
import PageApplicationToCloseList, { path as PageApplicationToCloseListPath } from 'pages/PageApplicationToCloseList';
import PageAppNoteList, { path as PageAppNoteListPath } from 'pages/PageAppNoteList';
import PageAppRoomTypeList, { path as PageAppRoomTypeListPath } from 'pages/PageAppRoomTypeList';
import PageAppSettings, { path as PageAppSettingsPath } from 'pages/PageAppSettings';
// Old matrix page — kept for reference, replaced by PagePositionMatrix
// import PageArea, { path as PageAreaPath } from 'pages/PageArea';
import PagePositionMatrix, { path as PageAreaPath } from 'pages/PagePositionMatrix';
import PageAreaList, { path as PageAreaListPath } from 'pages/PageAreaList';
import PageAreaPpr, { path as PageAreaPprPath } from 'pages/PageAreaPpr';
import PageAreaPprList, { path as PageAreaPprListPath } from 'pages/PageAreaPprList';
import PageAreaPprMatrix, { path as PageAreaPprMatrixPath } from 'pages/PageAreaPprMatrix';
import PageServiceStandards, { path as PageStandardsPath } from 'pages/PageBIStandards';
import PageCalendar, { path as PageCalendarPath } from 'pages/PageCalendar';
import PageCapexCriticalLevelList, { path as PageCapexCriticalLevelListPath } from 'pages/PageCapexCriticalLevelList';
import PageCapexProgressList, { path as PageCapexProgressListPath } from 'pages/PageCapexProgressList';
import PageCapexReport, { path as PageCapexReportPath } from 'pages/PageCapexReport';
import PageChecklist, { path as PageChecklistPath } from 'pages/PageChecklist';
import PageChecklistAfterGroupList, {
  path as PageChecklistAfterGroupListPath,
} from 'pages/PageChecklistAfterGroupList';
import PageSelfManagedTeamList, {
  path as PageSelfManagedTeamListPath,
} from 'pages/PageSelfManagedTeamList';
import PageChecklistAfterIndicatorList, {
  path as PageChecklistAfterIndicatorListPath,
} from 'pages/PageChecklistAfterIndicatorList';
import PageChecklistAfterList, { path as PageChecklistAfterListPath } from 'pages/PageChecklistAfterList';
import PageChecklistAfterSeasonList, {
  path as PageChecklistAfterSeasonListPath,
} from 'pages/PageChecklistAfterSeasonList';
import PageChecklistApplicationList, {
  path as PageChecklistApplicationListPath,
} from 'pages/PageChecklistApplicationList';
import PageChecklistBeforeIndicatorList, {
  path as PageChecklistBeforeIndicatorListPath,
} from 'pages/PageChecklistBeforeIndicatorList';
import PageChecklistRegister, { path as PageChecklistRegisterPath } from 'pages/PageChecklistRegister';
import PageClientCard, { path as PageClientCardPath } from 'pages/PageClientCard';
import PageConclusionAct, { path as PageConclusionActPath } from 'pages/PageConclusionAct';
import PageSurveyAct, { path as PageSurveyActPath } from 'pages/PageSurveyAct';
import PageConfluence, { path as PageConfluencePath } from 'pages/PageConfluence';
import PageConstructiveList, { path as PageConstructiveListPath } from 'pages/PageConstructiveList';
import PageConsultations, { path as PageConsultationsPath } from 'pages/PageConsultations';
import PageContragentBadAdd, { path as PageContragentBadAddPath } from 'pages/PageContragentBadAdd';
import PageContagentBadDelete, { path as PageContagentBadDeletePath } from 'pages/PageContragentBadDelete';
import PageCostCategoryList, { path as PageCostCategoryListPath } from 'pages/PageCostCategoryList';
import PageCreateRole, { path as PageCreateRolePath } from 'pages/PageCreateRole';
import PageCriteriaRatingList, { path as PageCriteriaRatingListPath } from 'pages/PageCriteriaRatingList';
import PageCriteriaRatingUGOList, { path as PageCriteriaRatingUGOListPath } from 'pages/PageCriteriaRatingUGOList';
import PageDefectAct, { path as PageDefectActPath } from 'pages/PageDefectAct';
import PageDefectActBrandList, { path as PageDefectActBrandListPath } from 'pages/PageDefectActBrandList';
import PageDefectActDivisionList, { path as PageDefectActDivisionListPath } from 'pages/PageDefectActDivisionList';
import PageDefectActNew, { path as PageDefectActNewPath } from 'pages/PageDefectActNew';
import PageDefectActReasons, { path as PageDefectActReasonsPath } from 'pages/PageDefectActReasons';
import PageDefectActWorkGuaranteeList, {
  path as PageDefectActWorkGuaranteeListPath,
} from 'pages/PageDefectActWorkGuaranteeList';
import PageDefectTypeCostList, { path as PageDefectTypeCostListPath } from 'pages/PageDefectTypeCostList';
import PageDefectTypeList, { path as PageDefectTypeListPath } from 'pages/PageDefectTypeList';
import PageDelayApplicationReport, { path as PageDelayApplicationReportPath } from 'pages/PageDelayApplicationReport';
import PageDelayReasonClientList, { path as PageDelayReasonClientListPath } from 'pages/PageDelayReasonClientList';
import PageDelayReasons, { path as PageDelayReasonsPath } from 'pages/PageDelayReasons';
import PageDivisionList, { path as PageDivisionListPath } from 'pages/PageDivisionList';
import PageDoneApplications, { path as PageDoneApplicationsPath } from 'pages/PageDoneApplications';
import PageEmployee, { path as PageEmployeePath } from 'pages/PageEmployee';
import PageEmployeeList, { path as PageEmployeeListPath } from 'pages/PageEmployeeList';
import PageEquipments, { path as PageEquipmentsPath } from 'pages/PageEquipmentPprList';
import PageEquipmentTypes, { path as PageEquipmentTypesPath } from 'pages/PageEquipmentTypePprList';
import PageEvents, { path as PageEventsPath } from 'pages/PageEvents';
import PageEventTypeList, { path as PageEventTypeListPath } from 'pages/PageEventTypeList';
import PageExtraRolesList, { path as PageExtraRolesListPath } from 'pages/PageExtraRolesList';
import PageGpr, { path as PageGprPath } from 'pages/PageGpr';
import PageGprForm, { path as PageGprFormPath } from 'pages/PageGprForm';
import PageGprRun, { path as PageGprRunPath } from 'pages/PageGprRun';
import PageGroupApplicationList, { path as PageGroupApplicationListPath } from 'pages/PageGroupApplicationList';
import PageGroupApplicationReport, { path as PageGroupApplicationReportPath } from 'pages/PageGroupApplicationReport';
import PageHierarchyDiagram, { path as PageHierarchyDiagramPath } from 'pages/PageHierarchyDiagram';
import PageHome, { path as PageHomePath } from 'pages/PageHome';
import PageJournalEquipmentPprList, {
  path as PageJournalEquipmentPprListPath,
} from 'pages/PageJournalEquipmentPprList';
import PageKPIApplicationListDashboard, {
  path as PageKPIApplicationListDashboardPath,
} from 'pages/PageKPIApplicationListDashboard';
import PageKPIExecutorListDashboard, {
  path as PageKPIExecutorListDashboardPath,
} from 'pages/PageKPIExecutorListDashboard';
import PageKPIIndicatiorList, { path as PageKPIIndicatiorListPath } from 'pages/PageKPIIndicatorList';
import PageKPITypeList, { path as PageKPITypeListPath } from 'pages/PageKPITypeList';
import PageLogs, { path as PageLogsPath } from 'pages/PageLogs';
import PageMailingList, { path as PageMailingListPath } from 'pages/PageMailingList';
import PageManagementUGOList, { path as PageManagementUGOListPath } from 'pages/PageManagementUGOList';
import PageMoReportsList, { path as PageMoReportsListPath } from 'pages/PageMoReportsList';
import PageMyApplicationList, { path as PageMyApplicationListPath } from 'pages/PageMyApplicationList';
import PageMyNotificationList, { path as PageMyNotificationListPath } from 'pages/PageMyNotificationList';
import PageMyNotificationPprList, { path as PageMyNotificationListPprPath } from 'pages/PageMyNotificationPprList';
import PageNotFound, { path as PageNotFoundPath } from 'pages/PageNotFound';
import PageOrkChecklist, { path as PageOrkChecklistPath } from 'pages/PageOrkChecklist';
import PagePartnersRatingReport, { path as PagePartnersRatingReportPath } from 'pages/PagePartnersRatingReport';
import PagePersonnelTrainingList, { path as PagePersonnelTrainingListPath } from 'pages/PagePersonnelTrainingList';
import PagePositionList, { path as PagePositionListPath } from 'pages/PagePositionList';
import PageProjectEquipments, { path as PageProjectEquipmentsPath } from 'pages/PageProjectEquipmentPprList';
import PagePurchaseApplication, { path as PagePurchaseApplicationPath } from 'pages/PagePurchaseApplication';
import PagePurchaseApplicationList, {
  path as PagePurchaseApplicationListPath,
} from 'pages/PagePurchaseApplicationList';
import PageRealEstate, { path as PageRealEstatePath } from 'pages/PageRealEstate';
import PageRealEstatePpr, { path as PageRealEstatePprPath } from 'pages/PageRealEstatePpr';
import PageReasonUsoList, { path as PageReasonUsoListPath } from 'pages/PageReasonUsoList';
import PageReopenReasonList, { path as PageReopenReasonListPath } from 'pages/PageReopenReasonList';
import PageRepairTypes, { path as PageRepairTypesPath } from 'pages/PageRepairTypes';
import PageReports, { path as PageReportsPath } from 'pages/PageReports';
import PageReportsList, { path as PageReportsListPath } from 'pages/PageReportsList';
import PageServiceDictionary, { path as PageServiceDictionaryPath } from 'pages/PageServiceDictionary';
import PageServiceOrgList, { path as PageServiceOrgListPath } from 'pages/PageServiceOrgList';
import PageServiceTypeList, { path as PageServiceTypeListPath } from 'pages/PageServiceTypeList';
import PageSICDReportList, { path as PageSICDReportListPath } from 'pages/PageSICDReportList';
import PageSourceList, { path as PageSourceListPath } from 'pages/PageSourceList';
import PageStaffList, { path as PageStaffListPath } from 'pages/PageStaffList';
import PagePersonalRegistry, { path as PagePersonalRegistryPath } from 'pages/PagePersonalRegistry';
import PagePersonalRegistryMember, { path as PagePersonalRegistryMemberPath } from 'pages/PagePersonalRegistryMember';
import PageSubConstructiveList, { path as PageSubConstructiveListPath } from 'pages/PageSubConstructiveList';
import PageSubordinateReport, { path as PageSubordinateReportPath } from 'pages/PageSubordinateReport';
import PageSubZoneList, { path as PageSubZoneListPath } from 'pages/PageSubZoneList';
import PageSurvey, { path as PageSurveyPath } from 'pages/PageSurvey';
import PageSurveyCreate, { path as PageSurveyCreatePath } from 'pages/PageSurveyCreate';
import PageSurveyItem, { path as PageSurveyItemPath } from 'pages/PageSurveyItem';
import PageSurveyPreview, { path as PageSurveyPreviewPath } from 'pages/PageSurveyPreview';
import PageTariffIncreasePlanList, { path as PageTariffIncreasePlanListPath } from 'pages/PageTariffIncreasePlanList';
import PageTaskPpr, { path as PageTaskPprPath } from 'pages/PageTaskPpr';
import PageTaskPprList, { path as PageTaskPprListPath } from 'pages/PageTaskPprList';
import PageTaskPprListByStatus, { path as PageTaskPprListByStatusPath } from 'pages/PageTaskPprListByStatus';
import PageTaskReportPprList, { path as PageTaskReportPprListPath } from 'pages/PageTaskReportPprList';
import PageTechMapApplicationList, { path as PageTechMapApplicationListPath } from 'pages/PageTechMapApplicationList';
import PageTechMapWorkTypeList, { path as PageTechMapWorkTypeListPath } from 'pages/PageTechMapWorkTypeList';
import PageTechnicalRoomPpr, { path as PageTechnicalRoomPprPath } from 'pages/PageTechnicalRoomPpr';
import PageTempEmployeeList, { path as PageTempEmployeeListPath } from 'pages/PageTempEmployeeList';
import PageTypeTechnicalRoomPprList, {
  path as PageTypeTechnicalRoomPprListPath,
} from 'pages/PageTypeTechnicalRoomPprList';
import PageUserKPIList, { path as PageUserKPIListPath } from 'pages/PageUserKPIList';
import PageUsoApplicationList, { path as PageUsoApplicationListPath } from 'pages/PageUsoApplicationList';
import PageWarrantyCard, { path as PageWarrantyCardPath } from 'pages/PageWarrantyCard';
import PageWorkListPpr, { path as PageWorkListPprPath } from 'pages/PageWorkListPpr';
import PageWorkTypeList, { path as PageWorkTypeListPath } from 'pages/PageWorkTypeList';
import PageYardList, { path as PageYardListPath } from 'pages/PageYardList';
import PageObjectTypeList, { path as PageObjectTypeListPath } from 'pages/PageObjectTypeList';
import PageZoneList, { path as PageZoneListPath } from 'pages/PageZoneList';
import PageChronaVisitList, { path as PageChronaVisitListPath } from 'pages/Chrona/PageChronaVisitList';
import PageChronaVisitDashboard, {
  path as PageChronaVisitDashboardPath,
} from 'pages/Chrona/PageChronaVisitDashboard';
import PageChronaVisitHouse, { path as PageChronaVisitHousePath } from 'pages/Chrona/PageChronaVisitHouse';
import PageChronaObjectList, { path as PageChronaObjectListPath } from 'pages/Chrona/PageChronaObjectList';
import PageChronaGeoZoneEditor, {
  path as PageChronaGeoZoneEditorPath,
} from 'pages/Chrona/PageChronaGeoZoneEditor';
import PageChronaMatrix, { path as PageChronaMatrixPath } from 'pages/Chrona/PageChronaMatrix';
import PageChronaSettings, { path as PageChronaSettingsPath } from 'pages/Chrona/PageChronaSettings';
import PageChronaAuditLog, { path as PageChronaAuditLogPath } from 'pages/Chrona/PageChronaAuditLog';
import PageChronaMap, { path as PageChronaMapPath } from 'pages/Chrona/PageChronaMap';
import PageChronaAccess, { path as PageChronaAccessPath } from 'pages/Chrona/PageChronaAccess';


const Routes: React.FC = () => {
  return (
    <TrackedSwitch>
      <Route component={PageHome} exact path={PageHomePath} />
      <Route component={PageReportsList} exact path={PageReportsListPath} />
      <Route component={PageReports} exact path={PageReportsPath} />
      <Route component={PageAppIndicatorList} exact path={PageAppIndicatorListPath} />
      <Route component={PageAppRoomTypeList} exact path={PageAppRoomTypeListPath} />
      <Route component={PageAppNoteList} exact path={PageAppNoteListPath} />
      <Route component={PageGroupApplicationReport} exact path={PageGroupApplicationReportPath} />
      <Route component={PageDelayApplicationReport} exact path={PageDelayApplicationReportPath} />
      <Route component={PageSICDReportList} exact path={PageSICDReportListPath} />
      <Route component={PageSubordinateReport} exact path={PageSubordinateReportPath} />
      <Route component={PageApplicationList} exact path={PageApplicationListPath} />
      <Route component={PageMyApplicationList} exact path={PageMyApplicationListPath} />
      <Route component={PageMyNotificationList} exact path={PageMyNotificationListPath} />
      <Route component={PageMyNotificationPprList} exact path={PageMyNotificationListPprPath} />
      <Route component={PageApplicationPprList} exact path={PageApplicationPprListPath} />
      <Route component={PageApplicationQuestionableList} exact path={PageApplicationQuestionableListPath} />
      <Route component={PageGroupApplicationList} exact path={PageGroupApplicationListPath} />
      <Route component={PageTechMapApplicationList} exact path={PageTechMapApplicationListPath} />
      <Route component={PageUsoApplicationList} exact path={PageUsoApplicationListPath} />
      <Route component={PageTaskPprList} exact path={PageTaskPprListPath} />
      <Route component={PageTaskPprListByStatus} exact path={PageTaskPprListByStatusPath} />
      <Route component={PageTaskReportPprList} exact path={PageTaskReportPprListPath} />
      <Route component={PageCheckListSchemaList} exact path={PageCheckListSchemaListPath} />
      <Route component={PageProjectList} exact path={PageProjectListPath} />
      <Route component={PageProjectCalculations} exact path={PageProjectCalculationsPath} />
      <Route component={PageCalculation} exact path={PageCalculationPath} />
      <Route component={PageCheckList} exact path={PageCheckListPath} />
      <Route component={PageAmortizationList} exact path={PageAmortizationListPath} />
      <Route component={PageMaterialsOutsourcingList} exact path={PageMaterialsOutsourcingListPath} />
      <Route component={PagePersonalSalaryList} exact path={PagePersonalSalaryListPath} />
      <Route component={PageDepartmentList} exact path={PageDepartmentListPath} />
      <Route component={PageGateMarkList} exact path={PageGateMarkListPath} />
      <Route component={PageModelList} exact path={PageModelListPath} />
      <Route component={PagePriceListServicesList} exact path={PagePriceListServicesListPath} />
      <Route component={PagePersonalWorkloadList} exact path={PagePersonalWorkloadListPath} />
      <Route component={PageFixedItemList} exact path={PageFixedItemListPath} />
      <Route component={PageTaskPpr} exact path={PageTaskPprPath} />
      <Route component={PageApplicationToCloseList} exact path={PageApplicationToCloseListPath} />
      <Route component={PageCapexCriticalLevelList} exact path={PageCapexCriticalLevelListPath} />
      <Route component={PageCapexProgressList} exact path={PageCapexProgressListPath} />
      <Route component={PageCapexReport} exact path={PageCapexReportPath} />
      <Route component={PageChecklistRegister} exact path={PageChecklistRegisterPath} />
      <Route component={PageClientCard} exact path={PageClientCardPath} />
      <Route component={PageChecklist} exact path={PageChecklistPath} />
      <Route component={PageChecklistAfterGroupList} exact path={PageChecklistAfterGroupListPath} />
      <Route component={PageSelfManagedTeamList} exact path={PageSelfManagedTeamListPath} />
      <Route component={PageChecklistAfterList} exact path={PageChecklistAfterListPath} />
      <Route component={PageChecklistAfterIndicatorList} exact path={PageChecklistAfterIndicatorListPath} />
      <Route component={PageChecklistAfterSeasonList} exact path={PageChecklistAfterSeasonListPath} />
      <Route component={PageZoneList} exact path={PageZoneListPath} />
      <Route component={PageSubZoneList} exact path={PageSubZoneListPath} />
      <Route component={PageConstructiveList} exact path={PageConstructiveListPath} />
      <Route component={PageSubConstructiveList} exact path={PageSubConstructiveListPath} />
      <Route component={PagePersonnelTrainingList} exact path={PagePersonnelTrainingListPath} />
      <Route component={PageChecklistApplicationList} exact path={PageChecklistApplicationListPath} />
      <Route component={PageChecklistBeforeIndicatorList} exact path={PageChecklistBeforeIndicatorListPath} />
      <Route component={PageConfluence} exact path={PageConfluencePath} />
      <Route component={PageApplicationNew} exact path={PageApplicationNewPath} />
      <Route component={PageApplication} exact path={PageApplicationPath} />
      <Route component={PageApplicationPpr} exact path={PageApplicationPprPath} />
      <Route component={PageWarrantyCard} exact path={PageWarrantyCardPath} />
      <Route component={PageTechMapWorkTypeList} exact path={PageTechMapWorkTypeListPath} />
      <Route component={PageTariffIncreasePlanList} exact path={PageTariffIncreasePlanListPath} />
      <Route component={PageTechnicalRoomPpr} exact path={PageTechnicalRoomPprPath} />
      <Route component={PageTypeTechnicalRoomPprList} exact path={PageTypeTechnicalRoomPprListPath} />
      <Route component={PageEquipments} exact path={PageEquipmentsPath} />
      <Route component={PageEquipmentTypes} exact path={PageEquipmentTypesPath} />
      <Route component={PageGpr} exact path={PageGprPath} />
      <Route component={PageGprForm} exact path={PageGprFormPath} />
      <Route component={PageGprRun} exact path={PageGprRunPath} />
      <Route component={PageWorkListPpr} exact path={PageWorkListPprPath} />
      <Route component={PageJournalEquipmentPprList} exact path={PageJournalEquipmentPprListPath} />
      <Route component={PageProjectEquipments} exact path={PageProjectEquipmentsPath} />
      <Route component={PagePurchaseApplicationList} exact path={PagePurchaseApplicationListPath} />
      <Route component={PagePurchaseApplication} exact path={PagePurchaseApplicationPath} />
      <Route component={PageContragentBadAdd} exact path={PageContragentBadAddPath} />
      <Route component={PageContagentBadDelete} exact path={PageContagentBadDeletePath} />
      <Route component={PageWorkTypeList} exact path={PageWorkTypeListPath} />
      <Route component={PageDefectAct} exact path={PageDefectActPath} />
      <Route component={PageDefectActNew} exact path={PageDefectActNewPath} />
      <Route component={PagePositionMatrix} exact path={PageAreaPath} />
      <Route component={PageAreaList} exact path={PageAreaListPath} />
      <Route component={PageAreaPpr} exact path={PageAreaPprPath} />
      <Route component={PageAreaPprMatrix} exact path={PageAreaPprMatrixPath} />
      <Route component={PageAreaPprList} exact path={PageAreaPprListPath} />
      <Route component={PageServiceOrgList} exact path={PageServiceOrgListPath} />
      <Route component={PageRealEstatePpr} exact path={PageRealEstatePprPath} />
      <Route component={PageServiceTypeList} exact path={PageServiceTypeListPath} />
      <Route component={PageCostCategoryList} exact path={PageCostCategoryListPath} />
      <Route component={PageCriteriaRatingList} exact path={PageCriteriaRatingListPath} />
      <Route component={PageCriteriaRatingUGOList} exact path={PageCriteriaRatingUGOListPath} />
      <Route component={PageRealEstate} exact path={PageRealEstatePath} />
      {/* Более специфичный путь карточки — до плоского маршрута реестра, для безопасности при
      будущих правках (оба exact, оба сейчас однозначно различимы). */}
      <Route component={PagePersonalRegistryMember} exact path={PagePersonalRegistryMemberPath} />
      <Route component={PagePersonalRegistry} exact path={PagePersonalRegistryPath} />
      <Redirect from="/real-estate/:any" to="/" />
      <Route component={PageStaffList} exact path={PageStaffListPath} />
      <Route component={PageEmployee} exact path={PageEmployeePath} />
      <Route component={PageEmployeeList} exact path={PageEmployeeListPath} />
      <Route component={PageTempEmployeeList} exact path={PageTempEmployeeListPath} />
      <Route component={PageAppSettings} exact path={PageAppSettingsPath} />
      <Route component={PageExtraRolesList} exact path={PageExtraRolesListPath} />
      <Route component={PageDefectTypeList} exact path={PageDefectTypeListPath} />
      <Route component={PageDefectTypeCostList} exact path={PageDefectTypeCostListPath} />
      <Route component={PageEventTypeList} exact path={PageEventTypeListPath} />
      <Route component={PageMailingList} exact path={PageMailingListPath} />
      <Route component={PageManagementUGOList} exact path={PageManagementUGOListPath} />
      <Route component={PageEvents} exact path={PageEventsPath} />
      <Route component={PageSurvey} exact path={PageSurveyPath} />
      <Route component={PageSurveyCreate} exact path={PageSurveyCreatePath} />
      <Route component={PageSurveyItem} exact path={PageSurveyItemPath} />
      <Route component={PageSurveyPreview} exact path={PageSurveyPreviewPath} />
      <Route component={PageOrkChecklist} exact path={PageOrkChecklistPath} />
      <Route component={PageMoReportsList} exact path={PageMoReportsListPath} />
      <Route component={PagePartnersRatingReport} exact path={PagePartnersRatingReportPath} />
      <Route component={PageCreateRole} exact path={PageCreateRolePath} />
      <Route component={PagePositionList} exact path={PagePositionListPath} />
      <Route component={PageHierarchyDiagram} exact path={PageHierarchyDiagramPath} />
      <Route component={PageReasonUsoList} exact path={PageReasonUsoListPath} />
      <Route component={PageSourceList} exact path={PageSourceListPath} />
      <Route component={PageReopenReasonList} exact path={PageReopenReasonListPath} />
      <Route component={PageDefectActReasons} exact path={PageDefectActReasonsPath} />
      <Route component={PageDefectActWorkGuaranteeList} exact path={PageDefectActWorkGuaranteeListPath} />
      <Route component={PageDefectActBrandList} exact path={PageDefectActBrandListPath} />
      <Route component={PageDefectActDivisionList} exact path={PageDefectActDivisionListPath} />
      <Route component={PageRepairTypes} exact path={PageRepairTypesPath} />
      <Route component={PageLogs} exact path={PageLogsPath} />
      <Route component={PageServiceStandards} exact path={PageStandardsPath} />
      <Route component={PageCalendar} exact path={PageCalendarPath} />
      <Route component={PageServiceDictionary} exact path={PageServiceDictionaryPath} />
      <Route component={PageConclusionAct} exact path={PageConclusionActPath} />
      <Route component={PageSurveyAct} exact path={PageSurveyActPath} />
      <Route component={PageActsOnSigning} exact path={PageActsOnSigningPath} />
      <Route component={PageMySurveyActs} exact path={PageMySurveyActsPath} />
      <Route component={PageConsultations} exact path={PageConsultationsPath} />
      <Route component={PageDoneApplications} exact path={PageDoneApplicationsPath} />
      <Route component={PageDelayReasons} exact path={PageDelayReasonsPath} />
      <Route component={PageDelayReasonClientList} exact path={PageDelayReasonClientListPath} />
      <Route component={PageDivisionList} exact path={PageDivisionListPath} />
      <Route component={PageKPIApplicationListDashboard} exact path={PageKPIApplicationListDashboardPath} />
      <Route component={PageKPIExecutorListDashboard} exact path={PageKPIExecutorListDashboardPath} />
      <Route component={PageKPIIndicatiorList} exact path={PageKPIIndicatiorListPath} />
      <Route component={PageKPITypeList} exact path={PageKPITypeListPath} />
      <Route component={PageUserKPIList} exact path={PageUserKPIListPath} />
      <Route component={PageYardList} exact path={PageYardListPath} />
      <Route component={PageObjectTypeList} exact path={PageObjectTypeListPath} />
      <Route component={PageChronaVisitList} exact path={PageChronaVisitListPath} />
      <Route component={PageChronaVisitDashboard} exact path={PageChronaVisitDashboardPath} />
      <Route component={PageChronaVisitHouse} exact path={PageChronaVisitHousePath} />
      <Route component={PageChronaObjectList} exact path={PageChronaObjectListPath} />
      <Route component={PageChronaGeoZoneEditor} exact path={PageChronaGeoZoneEditorPath} />
      <Route component={PageChronaMatrix} exact path={PageChronaMatrixPath} />
      <Route component={PageChronaSettings} exact path={PageChronaSettingsPath} />
      <Route component={PageChronaAuditLog} exact path={PageChronaAuditLogPath} />
      <Route component={PageChronaMap} exact path={PageChronaMapPath} />
      <Route component={PageChronaAccess} exact path={PageChronaAccessPath} />
      <Route component={PageNotFound} exact path={PageNotFoundPath} />
    </TrackedSwitch>
  );
};

export default Routes;
